import { render, staticRenderFns } from "./ChapmanAgents.vue?vue&type=template&id=3c255bb8"
import script from "./ChapmanAgents.vue?vue&type=script&lang=js"
export * from "./ChapmanAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports